import { mutations, actions, getters } from '@js/configs/globalModuleMethods'

const globalModule = {
    // State
    state: {
        mappings: {
            loanPurposes: [],
            loanTerms: {
                shortTerm: [
                    {
                        name: '3 months',
                        value: 3,
                    },
                    {
                        name: '6 months',
                        value: 6,
                    },
                    {
                        name: '9 months',
                        value: 9,
                    },
                    {
                        name: '1 year',
                        value: 12,
                    },
                    {
                        name: '2 years',
                        value: 24,
                    },
                    {
                        name: '3 years',
                        value: 36,
                    },
                    {
                        name: '4 years',
                        value: 48,
                    },
                    {
                        name: '5+ years',
                        value: 60,
                    },
                ],
                longTerm: [
                    {
                        name: '1 year',
                        value: 12,
                    },
                    {
                        name: '2 years',
                        value: 24,
                    },
                    {
                        name: '3 years',
                        value: 36,
                    },
                    {
                        name: '4 years',
                        value: 48,
                    },
                    {
                        name: '5+ years',
                        value: 60,
                    },
                ],
            },
        },
        data: {
            showErrorPage: false,
            errorPage: {},
            loanTermThreshold: 1000,
            showGeneralLoader: true,
        },
    },

    // Mutations
    mutations: mutations,

    // Actions
    actions: actions,

    // Getters
    getters: getters,
}

export default globalModule
